import { first } from 'remeda';
import type { Id } from 'types';

type MutationOptions = { onSuccess?: () => void };

type OpenAmlCaseOptions<TAmlData> = {
  amlData: TAmlData;
  invoiceIds: ReadonlyArray<Id>;
  thirdPartyCompanyId: Id;
  additionalInvoiceIds: Array<Id>;
  createAmlPdf: (variables: { data: TAmlData }, options?: MutationOptions) => void;
  sendToThirdParty: (
    variables: {
      id: string;
      data: { third_party_company_id: string; additional_invoices: Array<Id> };
    },
    options?: MutationOptions,
  ) => void;
  onSubmit: (values: Record<string, unknown>) => void;
  onSendSuccess?: () => void;
  navigate: (path: string) => void;
  closeModals: () => void;
};

export const isBatchOfInvoices = (invoiceIds: ReadonlyArray<Id>) => invoiceIds.length > 1;

export const openAmlCase = <TAmlData>({
  amlData,
  invoiceIds,
  thirdPartyCompanyId,
  additionalInvoiceIds,
  createAmlPdf,
  sendToThirdParty,
  onSubmit,
  onSendSuccess,
  navigate,
  closeModals,
}: OpenAmlCaseOptions<TAmlData>) => {
  const isBatch = isBatchOfInvoices(invoiceIds);

  const handOverTheBatch = () => {
    closeModals();
    onSubmit({ third_party_company_id: String(thirdPartyCompanyId) });
  };

  const showTheOpenedCase = () => {
    if (onSendSuccess) {
      onSendSuccess();
      return;
    }

    navigate('/thirdparty-cases');
    closeModals();
  };

  const openTheSingleCase = () =>
    sendToThirdParty(
      {
        id: String(first(invoiceIds)),
        data: {
          third_party_company_id: String(thirdPartyCompanyId),
          additional_invoices: additionalInvoiceIds,
        },
      },
      { onSuccess: showTheOpenedCase },
    );

  createAmlPdf({ data: amlData }, { onSuccess: isBatch ? handOverTheBatch : openTheSingleCase });
};
